// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#year-select {
    width: 65px !important;
}
.datepicker input[type="text"], select {
    width: 2.8em;
    display: inline !important;
}
.datepicker .year-input {
    width: 3rem !important;
}
.datepicker .amPm-input {
    width: 3.2rem;
}
.datepicker p {
    display: inline !important;
    margin: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/date-picker/date-picker.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,WAAW;AACf","sourcesContent":["#year-select {\r\n    width: 65px !important;\r\n}\r\n.datepicker input[type=\"text\"], select {\r\n    width: 2.8em;\r\n    display: inline !important;\r\n}\r\n.datepicker .year-input {\r\n    width: 3rem !important;\r\n}\r\n.datepicker .amPm-input {\r\n    width: 3.2rem;\r\n}\r\n.datepicker p {\r\n    display: inline !important;\r\n    margin: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
